import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HotToastService } from '@ngneat/hot-toast';
import { GeneratePasswordResetTokenRequest } from 'src/app/core/dtos/dto';
import { BrandEnum } from 'src/app/core/dtos/enum';
import { HttpErrorResponseMessages } from 'src/app/core/dtos/http-error-response-messages';
import { AccountService } from 'src/app/core/services/account.service';
import { ConfigHelper } from 'src/app/core/services/helpers/config.helper';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  userForm: FormGroup;
  brandName: string;
  formSubmitted: boolean;
  brandId: BrandEnum;
  emailExistBody: string;

  @ViewChild('emailExists') emailModal: ModalComponent;

  get f() { return this.userForm.controls; }

  constructor(
    private configHelper: ConfigHelper,
    private formBuilder: FormBuilder,
    private accountService: AccountService,
    private toastService: HotToastService,
  ) { }

  ngOnInit(): void {
    this.userForm = this.formBuilder.group({
      email: ['', Validators.required],
    });
    this.brandName = this.configHelper.getBrandName();
    this.brandId = this.configHelper.getBrandId();
    this.setModalBody();
  }

  setModalBody() {
    if (this.brandId === BrandEnum.CAEL) {
      this.emailExistBody = 'Email address not found.  If you are a new user, sign up for a new CAEL account. </br> For further assistance, please contact us at <a href="mailto:info@cael.ca" target="_top">info@cael.ca</a> or at </br> 1-855-520-2235.';
    } else {
      this.emailExistBody = 'Email address not found.  If you are a new user, sign up for a new CELPIP account. </br> For further assistance, please contact us at <a href="mailto:info@celpip.ca" target="_top">info@celpip.ca</a> or at </br> 1-800-958-5186.';
    }
  }

  onSubmit() {
    const forgotPasswordRequest: GeneratePasswordResetTokenRequest = {
      email: this.userForm.controls.email.value
    };
    this.accountService.sendForgetPasswordEmail(forgotPasswordRequest).subscribe(
      () => {
        this.toastService.success("A password reset email has been sent to " + this.userForm.controls.email.value);
        this.formSubmitted = true;
      },
      (error: HttpErrorResponse) => {
        if (error.status === 400) {
          const errorMessage = error.error as HttpErrorResponseMessages;
          errorMessage.reasons.forEach(reasons => {
            this.toastService.warning(reasons.errorMessage);
            this.formSubmitted = false;
          });
        }
        if (error.status === 403) {
          this.emailModal.open();
        }
      });
  }
}
